export default {"src":"/_next/static/media/human_detection.5f74fcbd.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};